import GetCreditWorthiness from './GetCreditWorthiness'

export default GetCreditWorthiness
